let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9TLza")).then(() => parcelRequire('gx2YZ'));